
import styled, { css } from 'styled-components';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { withStyledSystem } from '@metropolis-io/theme';
import { iconSize } from '@metropolis-io/icons/iconSize';
import type { IconProps } from '@metropolis-io/icons/Icon';


import IconRedAlertCircle from './RedAlertCircle'
import IconAddCircleSolid from './AddCircleSolid'
import IconAddCircle from './AddCircle'
import IconAdd from './Add'
import IconAddress from './Address'
import IconAlertCircle from './AlertCircle'
import IconAlertOctagon from './AlertOctagon'
import IconAlertTriangle from './AlertTriangle'
import IconArrowDown from './ArrowDown'
import IconArrowLeft from './ArrowLeft'
import IconArrowRandom from './ArrowRandom'
import IconArrowRight from './ArrowRight'
import IconArrowUp from './ArrowUp'
import IconBellOff from './BellOff'
import IconBell from './Bell'
import IconBike from './Bike'
import IconBookmarkSolid from './BookmarkSolid'
import IconBookmark from './Bookmark'
import IconBusiness from './Business'
import IconCameraSolid from './CameraSolid'
import IconCamera from './Camera'
import IconCapacity from './Capacity'
import IconCarExitFilled from './CarExitFilled'
import IconCarExit from './CarExit'
import IconCar from './Car'
import IconCaretDown from './CaretDown'
import IconCaretLeft from './CaretLeft'
import IconCaretRight from './CaretRight'
import IconCaretUp from './CaretUp'
import IconCars from './Cars'
import IconCheckCircle2 from './CheckCircle2'
import IconCheckCircleSolid from './CheckCircleSolid'
import IconCheckCircle from './CheckCircle'
import IconCheck from './Check'
import IconChevronDown from './ChevronDown'
import IconChevronLeft from './ChevronLeft'
import IconChevronRight from './ChevronRight'
import IconChevronUp from './ChevronUp'
import IconCilEthernet from './CilEthernet'
import IconCircleSignal from './CircleSignal'
import IconClockFilled from './ClockFilled'
import IconClockInCircle from './ClockInCircle'
import IconCloseCircleSolid from './CloseCircleSolid'
import IconCloseCircle from './CloseCircle'
import IconClose from './Close'
import IconCountryFlagUsa from './CountryFlagUsa'
import IconCreditCard from './CreditCard'
import IconCurrentLocation from './CurrentLocation'
import IconDestinationCircleSolid from './DestinationCircleSolid'
import IconDestinationCircle from './DestinationCircle'
import IconDestination from './Destination'
import IconDollarSignInCircle from './DollarSignInCircle'
import IconDownload from './Download'
import IconEditLine from './EditLine'
import IconEditSquare from './EditSquare'
import IconEdit from './Edit'
import IconEmail from './Email'
import IconEndTimeCircle from './EndTimeCircle'
import IconEnterpriseLocation from './EnterpriseLocation'
import IconEnterprise from './Enterprise'
import IconEraseBack from './EraseBack'
import IconExpandAlt from './ExpandAlt'
import IconExpand from './Expand'
import IconExternalWindow from './ExternalWindow'
import IconFilter from './Filter'
import IconGoogleSignin from './GoogleSignin'
import IconGrid from './Grid'
import IconHamburger from './Hamburger'
import IconHistory from './History'
import IconHomeSolid from './HomeSolid'
import IconHome from './Home'
import IconIn from './In'
import IconInfoCircleSolid from './InfoCircleSolid'
import IconInfoCircle from './InfoCircle'
import IconInfoFilled from './InfoFilled'
import IconInfo from './Info'
import IconInput from './Input'
import IconInvoice from './Invoice'
import IconKey from './Key'
import IconLayersIntersect from './LayersIntersect'
import IconLicensePlate from './LicensePlate'
import IconLocation from './Location'
import IconLockFilled from './LockFilled'
import IconLock from './Lock'
import IconLogoWordmark from './LogoWordmark'
import IconLogo from './Logo'
import IconMapMarkerLogo from './MapMarkerLogo'
import IconMarkerIn from './MarkerIn'
import IconMarkerOut from './MarkerOut'
import IconMenu from './Menu'
import IconMore from './More'
import IconNoPayment from './NoPayment'
import IconNoSubscription from './NoSubscription'
import IconNoValidation from './NoValidation'
import IconNotAVehicle from './NotAVehicle'
import IconOut from './Out'
import IconParkValidate from './ParkValidate'
import IconParkedPin from './ParkedPin'
import IconParkingFilled from './ParkingFilled'
import IconPay from './Pay'
import IconPaymentAmex from './PaymentAmex'
import IconPaymentApplePay from './PaymentApplePay'
import IconPaymentCardCvv from './PaymentCardCvv'
import IconPaymentCard from './PaymentCard'
import IconPaymentDinersClub from './PaymentDinersClub'
import IconPaymentDiscover from './PaymentDiscover'
import IconPaymentJcb from './PaymentJcb'
import IconPaymentMastercard from './PaymentMastercard'
import IconPaymentV2Amex from './PaymentV2Amex'
import IconPaymentV2DinersClub from './PaymentV2DinersClub'
import IconPaymentV2Discover from './PaymentV2Discover'
import IconPaymentV2Mastercard from './PaymentV2Mastercard'
import IconPaymentV2Visa from './PaymentV2Visa'
import IconPaymentVisa from './PaymentVisa'
import IconPhone from './Phone'
import IconPlayButtonCircle from './PlayButtonCircle'
import IconQrScan2 from './QrScan2'
import IconQrScan from './QrScan'
import IconQuestionCircle from './QuestionCircle'
import IconRead from './Read'
import IconRefresh from './Refresh'
import IconRoleAdmin from './RoleAdmin'
import IconRoleCustom from './RoleCustom'
import IconRoleReadOnly from './RoleReadOnly'
import IconRoleSpecialist from './RoleSpecialist'
import IconRoleSuperAdmin from './RoleSuperAdmin'
import IconRoute from './Route'
import IconSearch from './Search'
import IconShadowNone from './ShadowNone'
import IconShareAndroid from './ShareAndroid'
import IconShareIos from './ShareIos'
import IconShield from './Shield'
import IconSignage from './Signage'
import IconSiteCircleSolid from './SiteCircleSolid'
import IconSiteCircle from './SiteCircle'
import IconSitePin from './SitePin'
import IconSquareHalf from './SquareHalf'
import IconStarSolid from './StarSolid'
import IconStar from './Star'
import IconStop from './Stop'
import IconSubscriber from './Subscriber'
import IconSync from './Sync'
import IconTimer from './Timer'
import IconTrash from './Trash'
import IconUnlink from './Unlink'
import IconUnlock from './Unlock'
import IconUnreadablePlate from './UnreadablePlate'
import IconUserAdd from './UserAdd'
import IconUserCircle from './UserCircle'
import IconUser from './User'
import IconValetCircleSolid from './ValetCircleSolid'
import IconValetPin from './ValetPin'
import IconValetThirdParty from './ValetThirdParty'
import IconValet from './Valet'
import IconValidate from './Validate'
import IconValidationFilled from './ValidationFilled'
import IconValidationPin from './ValidationPin'
import IconValidation from './Validation'
import IconWalk from './Walk'
import IconWildcard from './Wildcard'
import IconWordmark from './Wordmark'
import IconWork from './Work'
import IconWrongDirection from './WrongDirection'
import IconZoomIn from './ZoomIn'
import IconZoomOut from './ZoomOut'
import IconZoom from './Zoom'
export const RedAlertCircle = styled(IconRedAlertCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
RedAlertCircle.displayName = 'RedAlertCircle';
RedAlertCircle.defaultProps = { fill: 'currentColor' };

export const AddCircleSolid = styled(IconAddCircleSolid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
AddCircleSolid.displayName = 'AddCircleSolid';
AddCircleSolid.defaultProps = { fill: 'currentColor' };

export const AddCircle = styled(IconAddCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
AddCircle.displayName = 'AddCircle';
AddCircle.defaultProps = { fill: 'currentColor' };

export const Add = styled(IconAdd).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Add.displayName = 'Add';
Add.defaultProps = { fill: 'currentColor' };

export const Address = styled(IconAddress).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Address.displayName = 'Address';
Address.defaultProps = { fill: 'currentColor' };

export const AlertCircle = styled(IconAlertCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
AlertCircle.displayName = 'AlertCircle';
AlertCircle.defaultProps = { fill: 'currentColor' };

export const AlertOctagon = styled(IconAlertOctagon).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
AlertOctagon.displayName = 'AlertOctagon';
AlertOctagon.defaultProps = { fill: 'currentColor' };

export const AlertTriangle = styled(IconAlertTriangle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
AlertTriangle.displayName = 'AlertTriangle';
AlertTriangle.defaultProps = { fill: 'currentColor' };

export const ArrowDown = styled(IconArrowDown).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ArrowDown.displayName = 'ArrowDown';
ArrowDown.defaultProps = { fill: 'currentColor' };

export const ArrowLeft = styled(IconArrowLeft).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ArrowLeft.displayName = 'ArrowLeft';
ArrowLeft.defaultProps = { fill: 'currentColor' };

export const ArrowRandom = styled(IconArrowRandom).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ArrowRandom.displayName = 'ArrowRandom';
ArrowRandom.defaultProps = { fill: 'currentColor' };

export const ArrowRight = styled(IconArrowRight).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ArrowRight.displayName = 'ArrowRight';
ArrowRight.defaultProps = { fill: 'currentColor' };

export const ArrowUp = styled(IconArrowUp).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ArrowUp.displayName = 'ArrowUp';
ArrowUp.defaultProps = { fill: 'currentColor' };

export const BellOff = styled(IconBellOff).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
BellOff.displayName = 'BellOff';
BellOff.defaultProps = { fill: 'currentColor' };

export const Bell = styled(IconBell).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Bell.displayName = 'Bell';
Bell.defaultProps = { fill: 'currentColor' };

export const Bike = styled(IconBike).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Bike.displayName = 'Bike';
Bike.defaultProps = { fill: 'currentColor' };

export const BookmarkSolid = styled(IconBookmarkSolid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
BookmarkSolid.displayName = 'BookmarkSolid';
BookmarkSolid.defaultProps = { fill: 'currentColor' };

export const Bookmark = styled(IconBookmark).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Bookmark.displayName = 'Bookmark';
Bookmark.defaultProps = { fill: 'currentColor' };

export const Business = styled(IconBusiness).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Business.displayName = 'Business';
Business.defaultProps = { fill: 'currentColor' };

export const CameraSolid = styled(IconCameraSolid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CameraSolid.displayName = 'CameraSolid';
CameraSolid.defaultProps = { fill: 'currentColor' };

export const Camera = styled(IconCamera).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Camera.displayName = 'Camera';
Camera.defaultProps = { fill: 'currentColor' };

export const Capacity = styled(IconCapacity).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Capacity.displayName = 'Capacity';
Capacity.defaultProps = { fill: 'currentColor' };

export const CarExitFilled = styled(IconCarExitFilled).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CarExitFilled.displayName = 'CarExitFilled';
CarExitFilled.defaultProps = { fill: 'currentColor' };

export const CarExit = styled(IconCarExit).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CarExit.displayName = 'CarExit';
CarExit.defaultProps = { fill: 'currentColor' };

export const Car = styled(IconCar).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Car.displayName = 'Car';
Car.defaultProps = { fill: 'currentColor' };

export const CaretDown = styled(IconCaretDown).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CaretDown.displayName = 'CaretDown';
CaretDown.defaultProps = { fill: 'currentColor' };

export const CaretLeft = styled(IconCaretLeft).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CaretLeft.displayName = 'CaretLeft';
CaretLeft.defaultProps = { fill: 'currentColor' };

export const CaretRight = styled(IconCaretRight).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CaretRight.displayName = 'CaretRight';
CaretRight.defaultProps = { fill: 'currentColor' };

export const CaretUp = styled(IconCaretUp).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CaretUp.displayName = 'CaretUp';
CaretUp.defaultProps = { fill: 'currentColor' };

export const Cars = styled(IconCars).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Cars.displayName = 'Cars';
Cars.defaultProps = { fill: 'currentColor' };

export const CheckCircle2 = styled(IconCheckCircle2).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CheckCircle2.displayName = 'CheckCircle2';
CheckCircle2.defaultProps = { fill: 'currentColor' };

export const CheckCircleSolid = styled(IconCheckCircleSolid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CheckCircleSolid.displayName = 'CheckCircleSolid';
CheckCircleSolid.defaultProps = { fill: 'currentColor' };

export const CheckCircle = styled(IconCheckCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CheckCircle.displayName = 'CheckCircle';
CheckCircle.defaultProps = { fill: 'currentColor' };

export const Check = styled(IconCheck).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Check.displayName = 'Check';
Check.defaultProps = { fill: 'currentColor' };

export const ChevronDown = styled(IconChevronDown).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ChevronDown.displayName = 'ChevronDown';
ChevronDown.defaultProps = { fill: 'currentColor' };

export const ChevronLeft = styled(IconChevronLeft).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ChevronLeft.displayName = 'ChevronLeft';
ChevronLeft.defaultProps = { fill: 'currentColor' };

export const ChevronRight = styled(IconChevronRight).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ChevronRight.displayName = 'ChevronRight';
ChevronRight.defaultProps = { fill: 'currentColor' };

export const ChevronUp = styled(IconChevronUp).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ChevronUp.displayName = 'ChevronUp';
ChevronUp.defaultProps = { fill: 'currentColor' };

export const CilEthernet = styled(IconCilEthernet).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CilEthernet.displayName = 'CilEthernet';
CilEthernet.defaultProps = { fill: 'currentColor' };

export const CircleSignal = styled(IconCircleSignal).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CircleSignal.displayName = 'CircleSignal';
CircleSignal.defaultProps = { fill: 'currentColor' };

export const ClockFilled = styled(IconClockFilled).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ClockFilled.displayName = 'ClockFilled';
ClockFilled.defaultProps = { fill: 'currentColor' };

export const ClockInCircle = styled(IconClockInCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ClockInCircle.displayName = 'ClockInCircle';
ClockInCircle.defaultProps = { fill: 'currentColor' };

export const CloseCircleSolid = styled(IconCloseCircleSolid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CloseCircleSolid.displayName = 'CloseCircleSolid';
CloseCircleSolid.defaultProps = { fill: 'currentColor' };

export const CloseCircle = styled(IconCloseCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CloseCircle.displayName = 'CloseCircle';
CloseCircle.defaultProps = { fill: 'currentColor' };

export const Close = styled(IconClose).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Close.displayName = 'Close';
Close.defaultProps = { fill: 'currentColor' };

export const CountryFlagUsa = styled(IconCountryFlagUsa).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CountryFlagUsa.displayName = 'CountryFlagUsa';
CountryFlagUsa.defaultProps = { fill: 'currentColor' };

export const CreditCard = styled(IconCreditCard).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CreditCard.displayName = 'CreditCard';
CreditCard.defaultProps = { fill: 'currentColor' };

export const CurrentLocation = styled(IconCurrentLocation).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
CurrentLocation.displayName = 'CurrentLocation';
CurrentLocation.defaultProps = { fill: 'currentColor' };

export const DestinationCircleSolid = styled(IconDestinationCircleSolid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
DestinationCircleSolid.displayName = 'DestinationCircleSolid';
DestinationCircleSolid.defaultProps = { fill: 'currentColor' };

export const DestinationCircle = styled(IconDestinationCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
DestinationCircle.displayName = 'DestinationCircle';
DestinationCircle.defaultProps = { fill: 'currentColor' };

export const Destination = styled(IconDestination).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Destination.displayName = 'Destination';
Destination.defaultProps = { fill: 'currentColor' };

export const DollarSignInCircle = styled(IconDollarSignInCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
DollarSignInCircle.displayName = 'DollarSignInCircle';
DollarSignInCircle.defaultProps = { fill: 'currentColor' };

export const Download = styled(IconDownload).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Download.displayName = 'Download';
Download.defaultProps = { fill: 'currentColor' };

export const EditLine = styled(IconEditLine).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
EditLine.displayName = 'EditLine';
EditLine.defaultProps = { fill: 'currentColor' };

export const EditSquare = styled(IconEditSquare).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
EditSquare.displayName = 'EditSquare';
EditSquare.defaultProps = { fill: 'currentColor' };

export const Edit = styled(IconEdit).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Edit.displayName = 'Edit';
Edit.defaultProps = { fill: 'currentColor' };

export const Email = styled(IconEmail).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Email.displayName = 'Email';
Email.defaultProps = { fill: 'currentColor' };

export const EndTimeCircle = styled(IconEndTimeCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
EndTimeCircle.displayName = 'EndTimeCircle';
EndTimeCircle.defaultProps = { fill: 'currentColor' };

export const EnterpriseLocation = styled(IconEnterpriseLocation).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
EnterpriseLocation.displayName = 'EnterpriseLocation';
EnterpriseLocation.defaultProps = { fill: 'currentColor' };

export const Enterprise = styled(IconEnterprise).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Enterprise.displayName = 'Enterprise';
Enterprise.defaultProps = { fill: 'currentColor' };

export const EraseBack = styled(IconEraseBack).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
EraseBack.displayName = 'EraseBack';
EraseBack.defaultProps = { fill: 'currentColor' };

export const ExpandAlt = styled(IconExpandAlt).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ExpandAlt.displayName = 'ExpandAlt';
ExpandAlt.defaultProps = { fill: 'currentColor' };

export const Expand = styled(IconExpand).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Expand.displayName = 'Expand';
Expand.defaultProps = { fill: 'currentColor' };

export const ExternalWindow = styled(IconExternalWindow).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ExternalWindow.displayName = 'ExternalWindow';
ExternalWindow.defaultProps = { fill: 'currentColor' };

export const Filter = styled(IconFilter).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Filter.displayName = 'Filter';
Filter.defaultProps = { fill: 'currentColor' };

export const GoogleSignin = styled(IconGoogleSignin).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
GoogleSignin.displayName = 'GoogleSignin';
GoogleSignin.defaultProps = { fill: 'currentColor' };

export const Grid = styled(IconGrid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Grid.displayName = 'Grid';
Grid.defaultProps = { fill: 'currentColor' };

export const Hamburger = styled(IconHamburger).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Hamburger.displayName = 'Hamburger';
Hamburger.defaultProps = { fill: 'currentColor' };

export const History = styled(IconHistory).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
History.displayName = 'History';
History.defaultProps = { fill: 'currentColor' };

export const HomeSolid = styled(IconHomeSolid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
HomeSolid.displayName = 'HomeSolid';
HomeSolid.defaultProps = { fill: 'currentColor' };

export const Home = styled(IconHome).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Home.displayName = 'Home';
Home.defaultProps = { fill: 'currentColor' };

export const In = styled(IconIn).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
In.displayName = 'In';
In.defaultProps = { fill: 'currentColor' };

export const InfoCircleSolid = styled(IconInfoCircleSolid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
InfoCircleSolid.displayName = 'InfoCircleSolid';
InfoCircleSolid.defaultProps = { fill: 'currentColor' };

export const InfoCircle = styled(IconInfoCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
InfoCircle.displayName = 'InfoCircle';
InfoCircle.defaultProps = { fill: 'currentColor' };

export const InfoFilled = styled(IconInfoFilled).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
InfoFilled.displayName = 'InfoFilled';
InfoFilled.defaultProps = { fill: 'currentColor' };

export const Info = styled(IconInfo).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Info.displayName = 'Info';
Info.defaultProps = { fill: 'currentColor' };

export const Input = styled(IconInput).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Input.displayName = 'Input';
Input.defaultProps = { fill: 'currentColor' };

export const Invoice = styled(IconInvoice).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Invoice.displayName = 'Invoice';
Invoice.defaultProps = { fill: 'currentColor' };

export const Key = styled(IconKey).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Key.displayName = 'Key';
Key.defaultProps = { fill: 'currentColor' };

export const LayersIntersect = styled(IconLayersIntersect).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
LayersIntersect.displayName = 'LayersIntersect';
LayersIntersect.defaultProps = { fill: 'currentColor' };

export const LicensePlate = styled(IconLicensePlate).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
LicensePlate.displayName = 'LicensePlate';
LicensePlate.defaultProps = { fill: 'currentColor' };

export const Location = styled(IconLocation).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Location.displayName = 'Location';
Location.defaultProps = { fill: 'currentColor' };

export const LockFilled = styled(IconLockFilled).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
LockFilled.displayName = 'LockFilled';
LockFilled.defaultProps = { fill: 'currentColor' };

export const Lock = styled(IconLock).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Lock.displayName = 'Lock';
Lock.defaultProps = { fill: 'currentColor' };

export const LogoWordmark = styled(IconLogoWordmark).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
LogoWordmark.displayName = 'LogoWordmark';
LogoWordmark.defaultProps = { fill: 'currentColor' };

export const Logo = styled(IconLogo).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Logo.displayName = 'Logo';
Logo.defaultProps = { fill: 'currentColor' };

export const MapMarkerLogo = styled(IconMapMarkerLogo).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
MapMarkerLogo.displayName = 'MapMarkerLogo';
MapMarkerLogo.defaultProps = { fill: 'currentColor' };

export const MarkerIn = styled(IconMarkerIn).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
MarkerIn.displayName = 'MarkerIn';
MarkerIn.defaultProps = { fill: 'currentColor' };

export const MarkerOut = styled(IconMarkerOut).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
MarkerOut.displayName = 'MarkerOut';
MarkerOut.defaultProps = { fill: 'currentColor' };

export const Menu = styled(IconMenu).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Menu.displayName = 'Menu';
Menu.defaultProps = { fill: 'currentColor' };

export const More = styled(IconMore).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
More.displayName = 'More';
More.defaultProps = { fill: 'currentColor' };

export const NoPayment = styled(IconNoPayment).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
NoPayment.displayName = 'NoPayment';
NoPayment.defaultProps = { fill: 'currentColor' };

export const NoSubscription = styled(IconNoSubscription).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
NoSubscription.displayName = 'NoSubscription';
NoSubscription.defaultProps = { fill: 'currentColor' };

export const NoValidation = styled(IconNoValidation).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
NoValidation.displayName = 'NoValidation';
NoValidation.defaultProps = { fill: 'currentColor' };

export const NotAVehicle = styled(IconNotAVehicle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
NotAVehicle.displayName = 'NotAVehicle';
NotAVehicle.defaultProps = { fill: 'currentColor' };

export const Out = styled(IconOut).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Out.displayName = 'Out';
Out.defaultProps = { fill: 'currentColor' };

export const ParkValidate = styled(IconParkValidate).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ParkValidate.displayName = 'ParkValidate';
ParkValidate.defaultProps = { fill: 'currentColor' };

export const ParkedPin = styled(IconParkedPin).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ParkedPin.displayName = 'ParkedPin';
ParkedPin.defaultProps = { fill: 'currentColor' };

export const ParkingFilled = styled(IconParkingFilled).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ParkingFilled.displayName = 'ParkingFilled';
ParkingFilled.defaultProps = { fill: 'currentColor' };

export const Pay = styled(IconPay).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Pay.displayName = 'Pay';
Pay.defaultProps = { fill: 'currentColor' };

export const PaymentAmex = styled(IconPaymentAmex).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentAmex.displayName = 'PaymentAmex';
PaymentAmex.defaultProps = { fill: 'currentColor' };

export const PaymentApplePay = styled(IconPaymentApplePay).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentApplePay.displayName = 'PaymentApplePay';
PaymentApplePay.defaultProps = { fill: 'currentColor' };

export const PaymentCardCvv = styled(IconPaymentCardCvv).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentCardCvv.displayName = 'PaymentCardCvv';
PaymentCardCvv.defaultProps = { fill: 'currentColor' };

export const PaymentCard = styled(IconPaymentCard).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentCard.displayName = 'PaymentCard';
PaymentCard.defaultProps = { fill: 'currentColor' };

export const PaymentDinersClub = styled(IconPaymentDinersClub).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentDinersClub.displayName = 'PaymentDinersClub';
PaymentDinersClub.defaultProps = { fill: 'currentColor' };

export const PaymentDiscover = styled(IconPaymentDiscover).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentDiscover.displayName = 'PaymentDiscover';
PaymentDiscover.defaultProps = { fill: 'currentColor' };

export const PaymentJcb = styled(IconPaymentJcb).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentJcb.displayName = 'PaymentJcb';
PaymentJcb.defaultProps = { fill: 'currentColor' };

export const PaymentMastercard = styled(IconPaymentMastercard).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentMastercard.displayName = 'PaymentMastercard';
PaymentMastercard.defaultProps = { fill: 'currentColor' };

export const PaymentV2Amex = styled(IconPaymentV2Amex).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentV2Amex.displayName = 'PaymentV2Amex';
PaymentV2Amex.defaultProps = { fill: 'currentColor' };

export const PaymentV2DinersClub = styled(IconPaymentV2DinersClub).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentV2DinersClub.displayName = 'PaymentV2DinersClub';
PaymentV2DinersClub.defaultProps = { fill: 'currentColor' };

export const PaymentV2Discover = styled(IconPaymentV2Discover).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentV2Discover.displayName = 'PaymentV2Discover';
PaymentV2Discover.defaultProps = { fill: 'currentColor' };

export const PaymentV2Mastercard = styled(IconPaymentV2Mastercard).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentV2Mastercard.displayName = 'PaymentV2Mastercard';
PaymentV2Mastercard.defaultProps = { fill: 'currentColor' };

export const PaymentV2Visa = styled(IconPaymentV2Visa).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentV2Visa.displayName = 'PaymentV2Visa';
PaymentV2Visa.defaultProps = { fill: 'currentColor' };

export const PaymentVisa = styled(IconPaymentVisa).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PaymentVisa.displayName = 'PaymentVisa';
PaymentVisa.defaultProps = { fill: 'currentColor' };

export const Phone = styled(IconPhone).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Phone.displayName = 'Phone';
Phone.defaultProps = { fill: 'currentColor' };

export const PlayButtonCircle = styled(IconPlayButtonCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
PlayButtonCircle.displayName = 'PlayButtonCircle';
PlayButtonCircle.defaultProps = { fill: 'currentColor' };

export const QrScan2 = styled(IconQrScan2).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
QrScan2.displayName = 'QrScan2';
QrScan2.defaultProps = { fill: 'currentColor' };

export const QrScan = styled(IconQrScan).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
QrScan.displayName = 'QrScan';
QrScan.defaultProps = { fill: 'currentColor' };

export const QuestionCircle = styled(IconQuestionCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
QuestionCircle.displayName = 'QuestionCircle';
QuestionCircle.defaultProps = { fill: 'currentColor' };

export const Read = styled(IconRead).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Read.displayName = 'Read';
Read.defaultProps = { fill: 'currentColor' };

export const Refresh = styled(IconRefresh).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Refresh.displayName = 'Refresh';
Refresh.defaultProps = { fill: 'currentColor' };

export const RoleAdmin = styled(IconRoleAdmin).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
RoleAdmin.displayName = 'RoleAdmin';
RoleAdmin.defaultProps = { fill: 'currentColor' };

export const RoleCustom = styled(IconRoleCustom).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
RoleCustom.displayName = 'RoleCustom';
RoleCustom.defaultProps = { fill: 'currentColor' };

export const RoleReadOnly = styled(IconRoleReadOnly).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
RoleReadOnly.displayName = 'RoleReadOnly';
RoleReadOnly.defaultProps = { fill: 'currentColor' };

export const RoleSpecialist = styled(IconRoleSpecialist).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
RoleSpecialist.displayName = 'RoleSpecialist';
RoleSpecialist.defaultProps = { fill: 'currentColor' };

export const RoleSuperAdmin = styled(IconRoleSuperAdmin).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
RoleSuperAdmin.displayName = 'RoleSuperAdmin';
RoleSuperAdmin.defaultProps = { fill: 'currentColor' };

export const Route = styled(IconRoute).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Route.displayName = 'Route';
Route.defaultProps = { fill: 'currentColor' };

export const Search = styled(IconSearch).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Search.displayName = 'Search';
Search.defaultProps = { fill: 'currentColor' };

export const ShadowNone = styled(IconShadowNone).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ShadowNone.displayName = 'ShadowNone';
ShadowNone.defaultProps = { fill: 'currentColor' };

export const ShareAndroid = styled(IconShareAndroid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ShareAndroid.displayName = 'ShareAndroid';
ShareAndroid.defaultProps = { fill: 'currentColor' };

export const ShareIos = styled(IconShareIos).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ShareIos.displayName = 'ShareIos';
ShareIos.defaultProps = { fill: 'currentColor' };

export const Shield = styled(IconShield).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Shield.displayName = 'Shield';
Shield.defaultProps = { fill: 'currentColor' };

export const Signage = styled(IconSignage).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Signage.displayName = 'Signage';
Signage.defaultProps = { fill: 'currentColor' };

export const SiteCircleSolid = styled(IconSiteCircleSolid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
SiteCircleSolid.displayName = 'SiteCircleSolid';
SiteCircleSolid.defaultProps = { fill: 'currentColor' };

export const SiteCircle = styled(IconSiteCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
SiteCircle.displayName = 'SiteCircle';
SiteCircle.defaultProps = { fill: 'currentColor' };

export const SitePin = styled(IconSitePin).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
SitePin.displayName = 'SitePin';
SitePin.defaultProps = { fill: 'currentColor' };

export const SquareHalf = styled(IconSquareHalf).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
SquareHalf.displayName = 'SquareHalf';
SquareHalf.defaultProps = { fill: 'currentColor' };

export const StarSolid = styled(IconStarSolid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
StarSolid.displayName = 'StarSolid';
StarSolid.defaultProps = { fill: 'currentColor' };

export const Star = styled(IconStar).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Star.displayName = 'Star';
Star.defaultProps = { fill: 'currentColor' };

export const Stop = styled(IconStop).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Stop.displayName = 'Stop';
Stop.defaultProps = { fill: 'currentColor' };

export const Subscriber = styled(IconSubscriber).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Subscriber.displayName = 'Subscriber';
Subscriber.defaultProps = { fill: 'currentColor' };

export const Sync = styled(IconSync).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Sync.displayName = 'Sync';
Sync.defaultProps = { fill: 'currentColor' };

export const Timer = styled(IconTimer).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Timer.displayName = 'Timer';
Timer.defaultProps = { fill: 'currentColor' };

export const Trash = styled(IconTrash).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Trash.displayName = 'Trash';
Trash.defaultProps = { fill: 'currentColor' };

export const Unlink = styled(IconUnlink).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Unlink.displayName = 'Unlink';
Unlink.defaultProps = { fill: 'currentColor' };

export const Unlock = styled(IconUnlock).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Unlock.displayName = 'Unlock';
Unlock.defaultProps = { fill: 'currentColor' };

export const UnreadablePlate = styled(IconUnreadablePlate).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
UnreadablePlate.displayName = 'UnreadablePlate';
UnreadablePlate.defaultProps = { fill: 'currentColor' };

export const UserAdd = styled(IconUserAdd).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
UserAdd.displayName = 'UserAdd';
UserAdd.defaultProps = { fill: 'currentColor' };

export const UserCircle = styled(IconUserCircle).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
UserCircle.displayName = 'UserCircle';
UserCircle.defaultProps = { fill: 'currentColor' };

export const User = styled(IconUser).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
User.displayName = 'User';
User.defaultProps = { fill: 'currentColor' };

export const ValetCircleSolid = styled(IconValetCircleSolid).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ValetCircleSolid.displayName = 'ValetCircleSolid';
ValetCircleSolid.defaultProps = { fill: 'currentColor' };

export const ValetPin = styled(IconValetPin).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ValetPin.displayName = 'ValetPin';
ValetPin.defaultProps = { fill: 'currentColor' };

export const ValetThirdParty = styled(IconValetThirdParty).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ValetThirdParty.displayName = 'ValetThirdParty';
ValetThirdParty.defaultProps = { fill: 'currentColor' };

export const Valet = styled(IconValet).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Valet.displayName = 'Valet';
Valet.defaultProps = { fill: 'currentColor' };

export const Validate = styled(IconValidate).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Validate.displayName = 'Validate';
Validate.defaultProps = { fill: 'currentColor' };

export const ValidationFilled = styled(IconValidationFilled).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ValidationFilled.displayName = 'ValidationFilled';
ValidationFilled.defaultProps = { fill: 'currentColor' };

export const ValidationPin = styled(IconValidationPin).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ValidationPin.displayName = 'ValidationPin';
ValidationPin.defaultProps = { fill: 'currentColor' };

export const Validation = styled(IconValidation).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Validation.displayName = 'Validation';
Validation.defaultProps = { fill: 'currentColor' };

export const Walk = styled(IconWalk).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Walk.displayName = 'Walk';
Walk.defaultProps = { fill: 'currentColor' };

export const Wildcard = styled(IconWildcard).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Wildcard.displayName = 'Wildcard';
Wildcard.defaultProps = { fill: 'currentColor' };

export const Wordmark = styled(IconWordmark).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Wordmark.displayName = 'Wordmark';
Wordmark.defaultProps = { fill: 'currentColor' };

export const Work = styled(IconWork).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Work.displayName = 'Work';
Work.defaultProps = { fill: 'currentColor' };

export const WrongDirection = styled(IconWrongDirection).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
WrongDirection.displayName = 'WrongDirection';
WrongDirection.defaultProps = { fill: 'currentColor' };

export const ZoomIn = styled(IconZoomIn).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ZoomIn.displayName = 'ZoomIn';
ZoomIn.defaultProps = { fill: 'currentColor' };

export const ZoomOut = styled(IconZoomOut).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
ZoomOut.displayName = 'ZoomOut';
ZoomOut.defaultProps = { fill: 'currentColor' };

export const Zoom = styled(IconZoom).withConfig({ shouldForwardProp }).attrs((props: IconProps) => ({
        ...withStyledSystem(props),
        width: iconSize(props).width,
        height: iconSize(props).height,
      }))<IconProps>`
      ${withStyledSystem}
  `;
Zoom.displayName = 'Zoom';
Zoom.defaultProps = { fill: 'currentColor' };
